import React from "react";

const style = {
  color: "white",
  backgroundColor: "black",
  padding: "10vh",
};

const Footer = () => {
  return (
    <div style={style} className="text-center fw-bold">
      <p className="fs-6">
        &copy; {new Date().getFullYear()} All Rights Reserved By Md. Ahanaf
        Tahmid Islam
        <br />
        Mirpur-2, Dhaka-1216, Bangladesh
      </p>
      <div className="text-center">
        <a
          href="https://www.linkedin.com/in/tahmidbd/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fs-1 px-2"
            src="https://img.icons8.com/color/48/000000/linkedin.png"
            alt=""
          />
        </a>
        &nbsp;&nbsp;
        <a
          href="https://github.com/Tahmid-islam"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fs-1 px-2"
            src="https://img.icons8.com/color/48/000000/github.png"
            alt=""
          />
        </a>
        &nbsp;&nbsp;
        <a
          href="https://www.facebook.com/ahanaf.tahmid.islam"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fs-1 px-2"
            src="https://img.icons8.com/color/48/000000/facebook-new.png"
            alt=""
          />
        </a>
        &nbsp;&nbsp;
        <a
          href="https://www.instagram.com/____ahanaf____/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fs-1 px-2"
            src="https://img.icons8.com/fluency/48/000000/instagram-new.png"
            alt=""
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
